import { BigRedButton } from "../BigRedButton"


export const BurgerMenu=({isBurgerActive})=>{
    
    
    return(
        <div className={`burger-menu ${isBurgerActive?'active':''}`}>
            <div className="burger-menu-row">
                <BigRedButton text='go back'/>
                <a href="#" className="header_link"><p>story</p></a>
                <a href="#" className="header_link"><p>story</p></a>
                <div className="collapse header_red-dot"></div>
                <img src={require("../../static/IMAGE_header_logo_ujjo.png")}/>
                <div className="collapse header_purple-dot"></div>
                <a href="#" className="header_link"><p>story</p></a>
                <a href="#" className="header_link"><p>story</p></a>
                <BigRedButton text='close'/>
            </div>
        </div>
    )
}